import React, { useState, useEffect, useRef } from "react";
import { AnalyticsPageStyle } from "./Configuration.style";
import TopBar from "../../components/TopBar/TopBar";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import Footer from "../../components/footer/Footer";
import TotalNoCard from "../../components/TotalNoCard/TotalNoCard";
import PercentageCard from "../../components/PercentageCard/PercentageCard";
import SponsorshipByDurationCard from "../../components/sponsors/SponsorshipByDurationCard";
import ReportsDropdown from "../../components/ReportsDropdown/ReportsDropdown";
import { useNavigate } from "react-router-dom";
import ROUTE from "../../common/Routes";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useReload } from "../../context/ReloadContext";
import { toast } from "react-toastify";
import {
  getSponsorConfigurationData,
  getSponsorCount,
  getSponsorsDashboardData,
} from "../../api/SponsorshipApi";
import { useDB } from "../../context/DynamoDBContext";
import { useSelector } from "react-redux";

const AnalyticsPage = () => {
  const navigate = useNavigate();

  const { access_token } = useSelector((state) => state.userKeyRed);
  const { dynamoDBClient } = useDB();
  const queryClient = useQueryClient();
  const { reload } = useReload();
  const [preset, setPreset] = useState("");
  const [enableConfigApi, setEnableConfigApi] = useState(false);
  const [enableApi, setEnableApi] = useState(true);
  const [fullPlacements, setFullPlacements] = useState(0);
  const [allPlacements, setallPlacements] = useState(0);
  const [totalSponsors, setTotalSponsors] = useState(0);
  const [lockScreenWidget, setLockScreenWidget] = useState(0);
  const [homeScreenWidget, setHomeScreenWidget] = useState(0);
  const [splashScreenWidget, setSplashScreenWidget] = useState(0);
  const [appScrollBanner, setAppScrollBanner] = useState(0);
  const [movementNotif, setMovementNotif] = useState(0);
  const [safetyErNotif, setSafetyErNotif] = useState(0);
  const [weeklyEmail, setWeeklyEmail] = useState();
  const [weeklyReport, setWeeklyReport] = useState(0);
  const [weeklyReportNotif, setWeeklyReportNotif] = useState(0);
  const [lockScreenWidgetDuration, setLockScreenWidgetDuration] = useState({});
  const [homeScreenWidgetDuration, setHomeScreenWidgetDuration] = useState({});
  const [splashScreenWidgetDuration, setSplashScreenWidgetDuration] = useState(
    {}
  );
  const [appScrollBannerDuration, setAppScrollBannerDuration] = useState({});
  const [movementNotifDuration, setMovementNotifDuration] = useState({});
  const [safetyErNotifDuration, setSafetyErNotifDuration] = useState({});
  const [weeklyEmailDuration, setWeeklyEmailDuration] = useState({});
  const [weeklyReportDuration, setWeeklyReportDuration] = useState({});
  const [weeklyReportNotifDuration, setWeeklyReportNotifDuration] = useState(
    {}
  );
  const [totalSponsorPlac, setTotalSponsorPlac] = useState(0);
  const [sponsorPlacePercentage, setSponsorPlacePercentage] = useState(0);
  const [allowedSponsors, setAllowedSponsors] = useState(0);
  const [sponsorCount, setSponsorCount] = useState(0);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (reload) {
      setEnableApi(true);
      setEnableConfigApi(true);
      queryClient.fetchQuery(["getSponsorConfigurations"]);
      queryClient.fetchQuery(["getSponsorDashboard"]);
      queryClient.fetchQuery(["getSponsorCount"]);
    }
  }, [reload]);

  useEffect(() => {
    if (dynamoDBClient) {
      setEnableConfigApi(true);
    } else {
      setEnableConfigApi(false);
    }
  }, [dynamoDBClient]);

  const handleError = (type) => {
    if (type === "getSponsorDashboard") {
      toast.error("Error while loading data", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    if (type === "getSponsorConfigurations") {
      toast.error("Error while loading Configuration Data", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    if (type === "getSponsorCount") {
      toast.error("Error while loading Sponsors Table Data", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    if (type === "getSponsorCountExceeded") {
      toast.error("You have reached the maximum number of sponsors allowed.", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  const { data: dashboardData, status: dashboardStatus } = useQuery({
    queryKey: ["getSponsorDashboard"],
    queryFn: () => getSponsorsDashboardData(access_token),
    enabled: enableApi,
    onSuccess: (response) => {
      if (response) {
        setFullPlacements(response.fullPlacementCount || 0);
        setallPlacements(response.allPlacements || 0);
        setTotalSponsors(response.totalSponsors || 0);
        setLockScreenWidget(response.placementCount.Widget || 0);
        setTotalSponsorPlac(response.supportedPlacementCount || 0);
        setSponsorPlacePercentage(
          response.totalCoveredPlacementPercentage || 0
        );
        setAppScrollBanner(response.placementCount.App || 0);
        setSplashScreenWidget(response.placementCount.Splash || 0);
        setMovementNotif(response.placementCount.Movement || 0);
        setSafetyErNotif(response.placementCount.SafetyEmergency || 0);
        setWeeklyEmail(response.placementCount.WeeklyReportEmail || 0);
        setWeeklyReport(response.placementCount.WeeklySystemReport || 0);
        setWeeklyReportNotif(
          response.placementCount.WeeklySystemNotification || 0
        );
        setLockScreenWidgetDuration(
          response.placementDurationCounts.Widget || {}
        );

        setAppScrollBannerDuration(response.placementDurationCounts.App || {});
        setSplashScreenWidgetDuration(
          response.placementDurationCounts.Splash || {}
        );
        setMovementNotifDuration(
          response.placementDurationCounts.Movement || {}
        );
        setSafetyErNotifDuration(
          response.placementDurationCounts.SafetyEmergency || {}
        );
        setWeeklyEmailDuration(
          response.placementDurationCounts.WeeklyReportEmail || {}
        );
        setWeeklyReportDuration(
          response.placementDurationCounts.WeeklySystemReport || {}
        );
        setWeeklyReportNotifDuration(
          response.placementDurationCounts.WeeklySystemNotification || {}
        );
      }
      setEnableApi(false);
    },
    onError: (error) => {
      console.log("getSponsorDashboard :", error);
      handleError("getSponsorDashboard");
    },
  });

  const { data: configData, status: configStatus } = useQuery({
    queryKey: ["getSponsorConfigurations"],
    queryFn: () => getSponsorConfigurationData(dynamoDBClient),
    enabled: enableConfigApi,
    onSuccess: (response) => {
      setAllowedSponsors(response[0]?.ConfigurationData?.TotalSponsor);
    },
    onError: (error) => {
      console.log("getSponsorConfigurations :", error);
      handleError("getSponsorConfigurations");
    },
  });

  const { data: sponsorData, status: sponsorDataStatus } = useQuery({
    queryKey: ["getSponsorCount"],
    queryFn: () => getSponsorCount(dynamoDBClient),
    enabled: enableConfigApi,
    onSuccess: (response) => {
      setSponsorCount(response.Count || 0);
    },
    onError: (error) => {
      console.log("getSponsorCount :", error);
      handleError("getSponsorCount");
    },
  });

  // Move checkSponsorLimit to top-level so it can be called on button click
  async function checkSponsorLimit() {
    if (!dynamoDBClient) return;
    try {
      const params = {
        TableName: "Sponsors", // Change to your actual table name
        FilterExpression: "IsEnabled = :enabled",
        ExpressionAttributeValues: {
          ":enabled": true,
        },
      };
      const response = await dynamoDBClient.scan(params).promise();
      const enabledCount = response.Items ? response.Items.length : 0;
      if (enabledCount >= 12) {
        handleError("getSponsorCountExceeded");
        navigate(ROUTE.Analytics);
      } else {
        navigate(ROUTE.Sponsors);
      }
    } catch (err) {
      console.error("Error checking sponsor limit:", err);
      return false;
    }  }

  return (
    <AnalyticsPageStyle>
      <TopBar authorized={true} />
      <MainBodyStyle>        <div className="btn-div">
          <div className="btn-div1">
            <button
              type="submit"
              className={"btn form-button1"}
              onClick={() => {
                navigate(ROUTE.SponsorList);
              }}
            >
              Sponsor Account List
            </button>
            <button
              type="submit"
              className={"btn form-button1"}
              onClick={checkSponsorLimit}
            >
              Create Sponsor Account
            </button>          
            </div>
            
          {/* Independent Reports Dropdown */}
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: '50px', marginTop: '25px' }}>
            <ReportsDropdown />
          </div>
        </div>
        <div className="main">
          <TotalNoCard heading={"Total Sponsors"} total={totalSponsors} />
          <TotalNoCard
            heading={"Full Placement Sponsors"}
            total={fullPlacements}
          />
          <TotalNoCard
            heading={"Total Sponsorship Placements"}
            total={`${allPlacements} of ${totalSponsorPlac}`}
          />
          <TotalNoCard
            heading={"Sponsorship Placement %"}
            total={Number(sponsorPlacePercentage).toFixed(2)}
          />
        </div>
        <div className="main">
          <PercentageCard
            heading={"Total Home/Lock Screen Widget Sponsorships"}
            total={lockScreenWidget}
          />

          <PercentageCard
            heading={"Total App Splash Screen Sponsorships"}
            total={splashScreenWidget}
          />
          <PercentageCard
            heading={"Total App Scroll Banner Sponsorships"}
            total={appScrollBanner}
          />
          <PercentageCard
            heading={"Total Movement Notifications Sponsorships"}
            total={movementNotif}
          />
          <PercentageCard
            heading={"Total Safety ER Notifications Sponsorships"}
            total={safetyErNotif}
          />
          <PercentageCard
            heading={"Total Weekly Report Email Sponsorships"}
            total={weeklyEmail}
          />
          <PercentageCard
            heading={"Total Weekly Report Notification Sponsorships"}
            total={weeklyReportNotif}
          />
          <PercentageCard
            heading={"Total Weekly System Report Sponsorships"}
            total={weeklyReport}
          />
        </div>
        <div className="main2">
          <SponsorshipByDurationCard
            heading="Total Home/Lock Screen Widget Sponsorships by Duration"
            stats={lockScreenWidgetDuration}
          />

          <SponsorshipByDurationCard
            heading="Total App Splash Screen Sponsorships by Duration"
            stats={splashScreenWidgetDuration}
          />
          <SponsorshipByDurationCard
            heading="Total App Scroll Banner Sponsorships by Duration"
            stats={appScrollBannerDuration}
          />
          <SponsorshipByDurationCard
            heading="Total Movement Notifications Sponsorships by Duration"
            stats={movementNotifDuration}
          />
          <SponsorshipByDurationCard
            heading="Total Safety ER Notifications Sponsorships by Duration"
            stats={safetyErNotifDuration}
          />
          <SponsorshipByDurationCard
            heading="Total Weekly Report Email Sponsorships by Duration"
            stats={weeklyEmailDuration}
          />
          <SponsorshipByDurationCard
            heading="Total Weekly Report Notification Sponsorships by Duration"
            stats={weeklyReportNotifDuration}
          />
          <SponsorshipByDurationCard
            heading="Total Weekly System Report Sponsorships by Duration"
            stats={weeklyReportDuration}
          />
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </AnalyticsPageStyle>
  );
};

export default AnalyticsPage;
